import { useEffect, useRef, useState } from "react";
import { fdmMarkup } from "../data/fdmMarkup";
import "../pages/FdmPage.css";

export default function FdmContent() {
  const contentRef = useRef(null);
  const [openModalId, setOpenModalId] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(null);

  useEffect(() => {
    const root = contentRef.current;
    if (!root) return;
    root
      .querySelectorAll(".fdm-modal")
      .forEach((modal) =>
        modal.classList.toggle("active", modal.id === `modal-${openModalId}`),
      );
  }, [openModalId]);

  useEffect(() => {
    document.body.style.overflow = openModalId || lightboxImage ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [openModalId, lightboxImage]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setLightboxImage(null);
        setOpenModalId(null);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  const handleContentClick = (event) => {
    const image = event.target.closest(".fdm-images img");
    if (image) {
      setLightboxImage(image.currentSrc || image.src);
      return;
    }
    if (event.target.closest(".fdm-modal-close")) {
      setOpenModalId(null);
      return;
    }
    const modal = event.target.closest(".fdm-modal");
    if (modal && event.target === modal) {
      setOpenModalId(null);
      return;
    }
    const card = event.target.closest("[data-fdm-id]");
    if (card) setOpenModalId(card.dataset.fdmId);
  };

  return (
    <>
      <div
        ref={contentRef}
        className="fdm-page"
        onClick={handleContentClick}
        dangerouslySetInnerHTML={{ __html: fdmMarkup }}
      />
      {lightboxImage && (
        <div
          className="fdm-lightbox active"
          role="dialog"
          aria-modal="true"
          aria-label="Enlarged FDM image"
          onClick={() => setLightboxImage(null)}
        >
          <button className="fdm-lightbox-close" aria-label="Close image">
            ×
          </button>
          <img src={lightboxImage} alt="Enlarged operational guidance" />
        </div>
      )}
    </>
  );
}
